import immutableUpdate from 'immutable-update'
import * as actions from "./actions";

const initialState = {
    catalog: null,
};

const reducers = {

  [actions.REFRESH_CATALOG_DATA]: (state, action) => {

    return immutableUpdate(state, {
        catalog: action.payload.data
      });
  },
};

const reducer = (state = initialState, action) =>
  reducers[action.type] ? reducers[action.type](state, action) : state;

export default reducer;
